import { render, staticRenderFns } from "./GroupGeneric.vue?vue&type=template&id=634408c2"
import script from "./GroupGeneric.vue?vue&type=script&lang=ts"
export * from "./GroupGeneric.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports